import { DeviceService } from '../../core/services/device.service';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { User } from '../../core/models/classes/user';
import { UserService } from '../../core/services/user.service';
import { AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { RegionService } from '../../core/services/region.service';
import { Region } from '../../core/models/classes/region';
import { SelectionModel } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Device } from '../../core/models/classes/device';
import { MatDialog } from '@angular/material/dialog';
import { CreateUserDialogComponent } from '../configuration/createuser/createuser.component';
import { Role } from '../../core/models/enums/user-role';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  displayedUserColumns: string[] = [
    'name',
    'role',
    'domain',
    'firstName',
    'lastName',
    'email',
    'company',
    'status',
  ];
  displayedRegionColumns: string[] = ['name', 'area', 'status'];
  displayedDeviceColumns: string[] = [
    'name',
    'platform',
    'registeredon',
    'appversion',
  ];
  users: Observable<User[]>;
  sUsers: User[] = [];
  regions: Region[] = [];
  devices: Device[] = [];

  userCount = 0;
  regionCount = 0;
  deviceCount = 0;

  regionSelection = new SelectionModel<Region>(false, []);
  userSelection = new SelectionModel<User>(false, []);

  regionDataSourceOrg;
  regionDataSource;
  userDataSource;
  devDataSourceOrg;
  devDataSource;
  showCs: boolean = false;
  errorMessage: string;
  hasAccess: boolean = false;
  userName: string;

  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  constructor(
    private router: Router,
    private userService: UserService,
    private regionService: RegionService,
    private deviceService: DeviceService,
    public dialog: MatDialog
  ) {
    this.userDataSource = new MatTableDataSource([]);
    this.regionDataSource = new MatTableDataSource([]);
    this.regionDataSourceOrg = new MatTableDataSource([]);
    this.devDataSource = new MatTableDataSource([]);
    this.devDataSourceOrg = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.loadUsers();
    this.loadRegions();
    this.loadDevices();
  }

  loadDevices() {
    this.deviceService.getDevices().subscribe({
      next: (dev) => {
        this.devices = dev;
        if (dev !== null) {
          this.devDataSource.data = this.devices.reverse();
          this.deviceCount = this.devices.length;
          this.devDataSourceOrg.data = this.devDataSource.data;
        }
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  loadRegions() {
    this.regionService.getRegions().subscribe({
      next: (reg) => {
        this.regions = reg;
        this.regionDataSource.data = this.regions;
        this.regionCount = this.regions.length;
        this.regionDataSourceOrg.data = this.regionDataSource.data;
        this.loadRegionCount();
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  loadRegionCount() {
    if (this.regions.length !== 0) {
      this.regions.forEach((element) => {
        this.regionService.getUsers(element.id).subscribe({
          next: (data) => {
            element.numberofUsers = data.length;
          },
          error: (err) => {
            throw Error(err);
          },
        });
      });
    }
  }

  loadUsers() {
    this.loggedInUser();
    this.userService.getUsermanagementList().subscribe({
      next: (data) => {
        this.sUsers = data;
        this.sUsers.forEach((element) => {
          let role = Role[element.roleId];
          if (role === 'None') {
            element.role = $localize`None`;
          } else {
            element.role = role;
          }
          element.domain = element.cSID === 0 ? 'External' : 'cableScout';
        });

        var onlyExternal = this.sUsers.filter((x) => x.domain === 'External'); //display only External users hiding cS users

        this.userDataSource.data = onlyExternal.sort((a, b) =>
          a.id > b.id ? 1 : -1
        );

        this.userCount = this.sUsers.length;
      },
    });
  }

  ngAfterViewInit(): void {
    this.regionDataSource.sort = this.sort.toArray()[2];
    this.userDataSource.sort = this.sort.toArray()[0];
    this.devDataSource.sort = this.sort.toArray()[1];
  }

  onSelectedUser(user: User): void {
    this.router.navigate(['default/user', user.id]);
  }

  onSelectedDevice(device: string): void {
    const url = `device`;
    this.router.navigate([url]);
  }

  onSelectedRegion(region: Region): void {
    this.regionSelection.select(region);
    this.router.navigate(['default/region', region.id]);
  }

  addNewUser(): void {
    this.dialog.open(CreateUserDialogComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });

    this.dialog.afterAllClosed.subscribe(() => {
      this.loadUsers();
    });
  }

  loggedInUser() {
    var userId = localStorage.getItem('loginId');
    this.userService.getUser(+userId).subscribe({
      next: (data) => {
        this.userName = data.name;
        localStorage.setItem('name', this.userName);
        if (data.roleId !== 3) {
          this.hasAccess = true;
        }
      },
    });
  }

  setDisplayPermissions() {
    this.showCs = !this.showCs;

    if (this.showCs) {
      this.userDataSource = this.sUsers;
    } else {
      this.userDataSource = this.sUsers.filter((x) => x.domain === 'External');
    }

    this.userDataSource.data = this.userDataSource.sort((a, b) =>
      a.id > b.id ? 1 : -1
    );
  }

  userFilter(event: Event) {
    this.userDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
  }

  deviceFilter(event: Event) {
    this.devDataSource = this.devDataSourceOrg;
    this.devDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (this.devDataSource.filter === '') {
      this.devDataSource = this.devDataSourceOrg;
    } else {
      var filteredList = new MatTableDataSource<Device>(
        this.devDataSource.filteredData.filter(
          (x) =>
            x.id.toString().includes(this.devDataSource.filter) ||
            x.name.toLowerCase().includes(this.devDataSource.filter) ||
            x.manufacturer.toLowerCase().includes(this.devDataSource.filter)
        )
      );
      this.devDataSource = filteredList;
    }
  }

  regionFilter(event: Event) {
    this.regionDataSource = this.regionDataSourceOrg;
    this.regionDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (this.regionDataSource.filter === '') {
      this.regionDataSource = this.regionDataSourceOrg;
    } else {
      var filteredList = new MatTableDataSource<Region>(
        this.regionDataSource.filteredData.filter(
          (x) =>
            x.id.toString().includes(this.regionDataSource.filter) ||
            x.numberofUsers.toString().includes(this.regionDataSource.filter) ||
            x.name.toLowerCase().includes(this.regionDataSource.filter) ||
            x.cacheStatus.toLowerCase().includes(this.regionDataSource.filter)
        )
      );
      this.regionDataSource = filteredList;
    }
  }
}
